{
  "averageDailyUsage": {
    "title": "Average Daily Usage",
    "unitLabel": "Acre-Inches/Day"
  },
  "downloadWaterUsageReportButton": "Download Report",
  "estimatesWarning": {
    "message": "The data displayed here is derived from historical estimates and should not be used in official record keeping.",
    "title": "Viewing Historical Estimates"
  },
  "farmWideWaterUsage": {
    "title": "Farm-Wide Water Usage",
    "unitLabel": "Acre-Feet"
  },
  "flowSourceToggle": {
    "label": "Data Source: "
  },
  "flowSummaryTable": {
    "headings": {
      "peakFlowRate": "Peak Flow Rate (GPM)",
      "totalVolumeAcreFeet": "Total Volume (Ac. Ft.)"
    },
    "title": "Farm Water Usage Summary"
  },
  "flowTimeseries": {
    "axisLabels": {
      "y": "Volume (Acre-Feet)"
    },
    "title": "Usage Over Time"
  },
  "highestFlowRate": {
    "pumpWithDeviceName": "Pump: {{deviceName}}",
    "title": "Highest Flow Rate",
    "unitLabel": "Gallons/Minute"
  },
  "noDataFound": "No Data Found for Specified Filters",
  "peakDailyUsage": {
    "onWithDate": "On {{date, datetime}}",
    "title": "Peak Daily Usage",
    "unitLabel": "Acre-Inches"
  },
  "pumpFlowStackedTimeseries": {
    "axisLabels": {
      "y": "Volume (Acre Feet)"
    },
    "title": "Total Volume Over Time"
  },
  "pumpTotalHorizontalBar": {
    "axisLabels": {
      "x": "Volume (Acre-Feet)"
    },
    "title": "Total Volume by Pump"
  },
  "title": "Flow Analytics"
}
